import { z } from 'zod';
import { BaseEventSchema } from './Base';

export const AutomaticSessionSchema = BaseEventSchema.extend({
  type: z.enum(['phone', 'email']),
});

export const AutomaticSessionLoginSuccessSchema = BaseEventSchema.extend({
  method: z.enum(['biometric', 'verification_code']),
  type: z.enum(['phone', 'email']),
});

export const LastWhimInteractionsEventSchema = BaseEventSchema.extend({
  products_pages_checked: z.number().nullable(), // amount of navigations into product view
  total_products_added_to_cart: z.number().nullable(),
  total_units_added_to_cart: z.number().nullable(),
  total_money_added_to_cart: z.number().nullable(),
});

export const PrescriptionsCheckoutDataEventSchema = BaseEventSchema.extend({
  highest_prescription_type: z.string().nullable(),
});

export enum AutomaticEventTypes {
  // Session
  SessionVerificationCodeSent = 'automatic.session.verification_code_sent',
  SessionBiometricLoginAttempt = 'automatic.session.biometric_login_attempt',
  SessionLogout = 'automatic.session.logout',
  SessionLoginSuccess = 'automatic.session.login_success',
  SessionContactAlreadyExists = 'automatic.session.contact_already_exists',
  // Others
  LastWhimInteractions = 'automatic.last_whim_interactions',
  PrescriptionsCheckoutData = 'automatic.prescriptions_checkout_data',
}

export const AutomaticEventTrackingSchemas = {
  // Session
  [AutomaticEventTypes.SessionVerificationCodeSent]: AutomaticSessionSchema,
  [AutomaticEventTypes.SessionBiometricLoginAttempt]: BaseEventSchema,
  [AutomaticEventTypes.SessionLogout]: BaseEventSchema,
  [AutomaticEventTypes.SessionLoginSuccess]: AutomaticSessionLoginSuccessSchema,
  [AutomaticEventTypes.SessionContactAlreadyExists]: AutomaticSessionSchema,
  // Others
  [AutomaticEventTypes.LastWhimInteractions]: LastWhimInteractionsEventSchema,
  [AutomaticEventTypes.PrescriptionsCheckoutData]:
    PrescriptionsCheckoutDataEventSchema,
};
